var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpoMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f39eb457-c6a6-44cb-880e-e21c71d96e91",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-fd6a2eba-30d1-46d6-a804-d86c1f277ff6",
    x1: 52.5,
    y1: 56.5,
    x2: 52.5,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5ab583c2-9b54-4a75-b278-819898e77dfa",
    x1: 52.5,
    y1: 27.5,
    x2: 52.5,
    y2: 67,
    xlinkHref: "#uuid-fd6a2eba-30d1-46d6-a804-d86c1f277ff6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m69.99,56.5h-34.98c-.89,0-1.68.59-1.92,1.45l-4.86,17c-.37,1.28.59,2.55,1.92,2.55h44.7c1.33,0,2.29-1.27,1.92-2.55l-4.86-17c-.25-.86-1.03-1.45-1.92-1.45Z",
    fill: "url(#uuid-fd6a2eba-30d1-46d6-a804-d86c1f277ff6)",
    opacity: 0.25,
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5,27.5c-8.38,0-15.2,6.82-15.19,15.2,0,3.25,1.66,7.66,4.22,11.22,1.89,2.63,9.47,12.1,9.79,12.5.29.36.72.57,1.19.57s.9-.21,1.19-.57c.32-.4,7.89-9.87,9.79-12.5,2.56-3.56,4.22-7.97,4.22-11.22,0-8.38-6.81-15.2-15.19-15.2Zm0,21.36c-4.19,0-7.6-3.41-7.6-7.6s3.41-7.6,7.6-7.6,7.6,3.41,7.6,7.6-3.41,7.6-7.6,7.6Z",
    fill: "url(#uuid-5ab583c2-9b54-4a75-b278-819898e77dfa)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoMap);
export default __webpack_public_path__ + "static/media/expo_map.eace27252893927feb0df9140613aa7c.svg";
export { ForwardRef as ReactComponent };